class GiftNote extends HTMLElement {
  static observedAttributes = ["gift-wrap-item-key", "remove-gift-wrap-item"];

  constructor() {
    super();
  }

  connectedCallback() {
    this.timeout = null;
    this.giftNoteCheckbox = this.querySelector('[name="add-gift-note"]');
    this.giftNote = this.querySelector('[name="gift-note"]');
    this.savedNote = this.querySelector("[data-saved-note]");

    this.cta = this.querySelector("[data-cta]");
    this.cta.addEventListener("click", () => {
      this.content.style.height = null;
      if (this.saved) {
        this.removeAttribute("saved");
      } else {
        this._setCartNote(this.giftNote.value);
        this.savedNote.innerHTML = this.giftNote.value;
        this.setAttribute("saved", "");
      }
    });

    this.enableInput = this.querySelector("[data-enable]");
    this.enableInput.addEventListener("change", () => {
      if (this.enableInput.checked) {
        this.removeAttribute("saved");
        this.open();
        this._addGiftWrapItem();
      } else {
        this.closeAndRemove();
      }
    });

    this.giftNote.addEventListener("input", () => {
      this.cta.disabled = false;
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (
      name === "gift-wrap-item-key" &&
      oldValue &&
      oldValue !== "" &&
      newValue === ""
    ) {
      this.giftNoteCheckbox.checked = false;
      this.closeAndRemove();
    }

    if (
      name === "remove-gift-wrap-item" &&
      oldValue &&
      oldValue !== "true" &&
      newValue === "true"
    ) {
      this.closeAndRemove();
    }
  }

  closeAndRemove() {
    this.close();
    this._removeGiftWrapItem();
    this._setCartNote(null);
    this.giftNote.value = "";
    this.savedNote.innerHTML = "";
  }

  open() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    if (this.content) {
      this.content.style.display = "block";
      this.content.style.height = 0;
      this.content.style.opacity = 0;

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.content.style.height = null;
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      window.requestAnimationFrame(() => {
        this.content.style.height = `${this.content.scrollHeight}px`;
        this.content.style.opacity = 1;
      });
    }
  }

  close() {
    if (this.content) {
      this.removeEventListener("transitionend", this.handleTransitionEnd);

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.content.style.display = null;
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);
      this.content.style.height = `${this.content.scrollHeight}px`;

      window.requestAnimationFrame(() => {
        this.content.style.height = 0;
        this.content.style.opacity = 0;
      });
    }
  }

  get content() {
    return this.querySelector("[data-content]");
  }

  get saved() {
    return this.hasAttribute("saved");
  }

  get giftWrapVariantId() {
    return this.getAttribute("gift-wrap-variant-id");
  }

  get giftWrapItemKey() {
    return this.getAttribute("gift-wrap-item-key");
  }

  _addGiftWrapItem() {
    window.addToCart({ id: this.giftWrapVariantId, quantity: 1 });
  }

  _removeGiftWrapItem() {
    const key = this.giftWrapItemKey;

    if (key) {
      window.changeCart({ id: key, quantity: 0 });
    }
  }

  _setCartNote(note) {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      window.updateCart({
        attributes: {
          "Gift Message": note,
        },
      });
    }, 500);
  }
}

if (!customElements.get("gift-note")) {
  customElements.define("gift-note", GiftNote);
}
